import React, {useCallback, useContext, useState} from 'react';
import {Link} from 'react-router-dom';

import './accordion.scss';
import './services-operators.scss';
import AccordionComponent from '../../clean-components/services-operators/accordion';
import {useTranslation} from 'react-i18next';
import {isMobile} from 'react-device-detect';
import {DataContext} from '../../services/data-v2/data.context';
import {translate} from '../../services/translation/translationUtils';
import {useEffect} from 'react';
import {ServiceCatalogModel, ServiceModel} from '../../core/models';

function ServicesOperatorsComponent() {
    const {db, ready} = useContext(DataContext);
    const res: any = [];
    const [servicesList, setServicesList] = useState(res);
    const {t} = useTranslation();
    let style = {};
    if (isMobile) {
        style = {
            'height': '92vh',
        } as React.CSSProperties;
    }

    const getServiceCatalog = useCallback(async () => {
        const serviceGroups = await db?.dataSources?.serviceGroups.find();
        const services = await db?.dataSources?.services.find();

        const serviceCatalog: ServiceCatalogModel[] = [];

        if (!!serviceGroups && !!services) {
            serviceGroups.forEach((serviceGroup: any, index: number) => {
                serviceCatalog.push({group: serviceGroup, services: []});
                services.forEach((service: ServiceModel) => {
                    if (service.groupSlug === serviceGroup.slug) {
                        serviceCatalog[index]?.services.push(service);
                    }
                });
            });
            serviceCatalog.forEach((group: any, index: number) => {
                if (group.services.length === 0) {
                    serviceCatalog.splice(index, 1);
                }
            });
        }
        setServicesList(serviceCatalog);
    }, [db]);

    useEffect(() => {
        getServiceCatalog();
    }, [ready, db]);

    return (<div className="services-container" style={style}>
        <p className="services-description">{t('translation:misc_services_operators_description')}</p>
        {
            servicesList?.map((option: any, index: number) =>
                <div key={index}>
                    <AccordionComponent title={translate(option.group.name)} icon={option.group.slug} services={option.services}/>
                </div>)}
        <p className="services-operators-link">
            {t('translation:misc_services_operators_provider')}
            <Link to={{pathname: 'http://www.ambmobilitat.cat/Quejas/Quejas.aspx?Tipo=O'}} target="_blank">
                <span>
                    {t('translation:misc_services_operators_contact_us')}
                </span>
            </Link>
        </p>
    </div>
    );
}

export default ServicesOperatorsComponent;
